import { normalizarId } from '../hooks/useScope';

/**
 * Relê o registro depois de salvar e diz quais campos o servidor ACEITOU SEM
 * GRAVAR.
 *
 * Existe porque uma API pode responder 200 e ignorar um campo que ainda não
 * conhece — e aí a tela mente: diz que salvou, a lista mostra o valor antigo,
 * e ninguém sabe de quem é a culpa. Conferir custa uma leitura e transforma um
 * mistério em diagnóstico.
 *
 * Devolve [] quando tudo bate E TAMBÉM quando a releitura falha: acusar o
 * servidor com base numa leitura que não aconteceu seria pior que calar.
 */
export async function conferirGravacao(
  buscar: () => Promise<any>,
  esperado: Record<string, unknown>,
): Promise<string[]> {
  let gravado: any;
  try {
    gravado = await buscar();
  } catch {
    return [];
  }
  if (!gravado || typeof gravado !== 'object') return [];

  const divergentes: string[] = [];
  for (const [campo, valor] of Object.entries(esperado)) {
    if (valor === undefined) continue;
    if (!iguais(valor, gravado[campo])) divergentes.push(campo);
  }
  return divergentes;
}

/**
 * Comparação tolerante ao que não muda o significado: número contra string
 * numérica, nulo contra ausente, espaços em volta do texto.
 *
 * ZERO não é vazio — `0` e `null` são valores DIFERENTES aqui, como em todo o
 * resto desta base.
 */
function iguais(esperado: unknown, gravado: unknown): boolean {
  const vazio = (v: unknown) => v === null || v === undefined || v === '';
  if (vazio(esperado) && vazio(gravado)) return true;
  if (vazio(esperado) !== vazio(gravado)) return false;

  const idEsperado = normalizarId(esperado);
  const idGravado = normalizarId(gravado);
  if (idEsperado !== null && idGravado !== null) return idEsperado === idGravado;

  return String(esperado).trim().toLowerCase() === String(gravado).trim().toLowerCase();
}
